import { styled } from '@mui/material'
import { Link } from 'react-router-dom'

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.role.primary,
  cursor: 'pointer',
  fontWeight: 700,
}))

export default StyledLink
